import { http } from '../http';
import { consoleSerializer } from '@/providers/serializers/console/console';
import { authSerializer } from '@/providers/serializers/auth/auth';

/**
 * ConsoleAPI help to handle all the API that are used under console page
 */
export class ConsoleAPI {

    private static INSTANCE = new ConsoleAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/missioncontrol/v1';

    public getImpersonateUsersList(
        searchFilter: { offet: number, limit: number, filterBy?: string, query?: string}) {
        const endpoint = `${this.namespace}/admin/users/search`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, searchFilter).then((response) => {
            return consoleSerializer.impersonateUserListSerialzer(response.data);
        });
    }

    public getImpersonateLogin(userId: string) {
        const endpoint = `${this.namespace}/admin/impersonate/${userId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return authSerializer.sessionModelSerializer(response.data);
        });
    }

}

export const consoleAPI = ConsoleAPI.instance;
